<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/User/User' }">用户列表</el-breadcrumb-item>
            <el-breadcrumb-item>用户详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="margin-top:24px"></div>
        <el-tabs v-model="activeName" @tab-click="handlesClick">
            <el-tab-pane label="用户商品" name="userGoods">
                <userGoods ref="userGoodsRef" :id="userId" />
            </el-tab-pane>
            <el-tab-pane label="用户评论" name="userComments">
                <userComments ref="userCommentsRef" :id="userId" />
            </el-tab-pane>
            <el-tab-pane label="用户商品评论" name="userBeCommentedOn">
                <userBeCommentedOn ref="userBeCommentedOnRef" :id="userId" />
            </el-tab-pane>
        </el-tabs>
        <!-- <div @click="goback">aaa</div> -->
    </div>
</template>

<script>
import userGoods from './components/userGoods.vue'
import userComments from './components/userComments.vue'
import userBeCommentedOn from './components/userBeCommentedOn.vue'
export default {
    // 注册组件
    components: {
        userGoods,
        userComments,
        userBeCommentedOn
    },
    data() {
        return {
            activeName: "userGoods",
            userId: ''
        }
    },
    mounted() {
        let obj = this.$route.query.id;
        this.userId = obj
        console.log('this.userId', this.userId)
        // this.$refs.userGoodsRef.getUserGoodsList();
    },
    methods: {
        // 返回上级页面
        goback() {
            this.$router.back()
        },
        // 点击选项卡，调用对应的页面的查询列表接口
        handlesClick(val) {
            let tabName = val.name;
            if (tabName == "userGoods") {
                this.$refs.userGoodsRef.getUserGoodsList();
            } else if (tabName == "userComments") {
                this.$refs.userCommentsRef.getUserGoodsList();
            } else {
                this.$refs.userBeCommentedOnRef.getUserGoodsList();
            }
        }
    }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/user/UserDetails.vue